import { Col, Row } from 'antd';
import { InverterApi } from 'api/InverterApi';
import { useAppDispatch } from 'app/hooks';
import clsx from 'clsx';
import { inverterActions } from 'features/Inverter/inverterSlice';
import { inverterInfo } from 'models';
import moment from 'moment';
import * as React from 'react';
// import { gatewayActions } from '../GatewayInfo/gatewaySlice';
import style from './ItemInverterList.module.scss';
export interface ItemInverterListProps {
  item: inverterInfo;
  setIsShowDevicesDetail: (value: boolean) => void;
}

export default function ItemInverterList({ item, setIsShowDevicesDetail }: ItemInverterListProps) {
  const [itemInverter, setItemGateWay] = React.useState<inverterInfo>(item);
  const dispatch = useAppDispatch();
  React.useEffect(() => {
    (async () => {
      try {
        const response: inverterInfo = await InverterApi.fetchInverterInfo({
          type: 'inverter_id',
          id: item.id,
        });
        setItemGateWay({ ...itemInverter, ...response });
      } catch (error) {
        console.log('Failed to fetch plant details', error);
      }
    })();
  }, []);

  return (
    <Row
      onClick={() => {
        dispatch(inverterActions.fetchInverterInfo(item));
        setIsShowDevicesDetail(false);
      }}
      className={style.root}
    >
      <Col className={style.item_device} span={4}>
        {itemInverter.code}
      </Col>
      <Col className={style.item_device} span={4}>
        {itemInverter.label}
      </Col>
      <Col className={style.item_device} span={6}>
        {itemInverter.model}
      </Col>
      <Col className={style.item_device} span={4}>
        <div
          className={clsx(style.status_gateway_item, {
            [style.active]: itemInverter.active,
          })}
        >
          {itemInverter.active ? 'active' : 'inactive'}
        </div>
      </Col>
      <Col className={style.item_device} span={6}>
        {moment(itemInverter.last_activity_time).format('YYYY-MM-DD HH:mm:ss')}
      </Col>
    </Row>
  );
}
